/**
 * This image loader is bypassing the NextJS image optimization in favor of calling Cloudfront -> s3 directly.
 * Images loaded in this way will be made available in S3 if placed in the /public directory.
 *
 * Currently, Cloudfront is not setup for image optimization and any width or quality params do not have any affect.
 * This means that Network costs and page load speeds may be slightly higher.
 */
export default function imageLoader({ src, width, quality }) {
    return `${process.env.NEXT_PUBLIC_ROOT_URL}${src}?w=${width}&q=${quality || 75}`
}
